export default __webpack_public_path__ + "static/media/icon-menu-membership-default.d97f819d.svg";